<template>
    <table class="table table-bordered table-sm mb-0">
        <thead>
            <tr>
                <th colspan="12">
                    <div class="d-flex align-items-center justify-content-between">
                        Konum
                        <div v-if="clearable" class="bg-dark text-white c-pointer rounded pl-50 pr-50" v-on:click="clear">Sıfırla</div>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="text-success text-center font-weight-bolder bg-light">0</td>
                <td><b-form-radio v-model="value.LocationOfPart1" :value="0">-</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">0</td>
                <td><b-form-radio v-model="value.LocationOfPart2" :value="0">-</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">0</td>
                <td><b-form-radio v-model="value.LocationOfPart3" :value="0">-</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">0</td>
                <td><b-form-radio v-model="value.LocationOfPart4" :value="0">-</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">0</td>
                <td><b-form-radio v-model="value.LocationOfPart5" :value="0">-</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">0</td>
                <td><b-form-radio v-model="value.LocationOfPart6" :value="0">-</b-form-radio></td>
            </tr>
            <tr>
                <td class="text-success text-center font-weight-bolder bg-light">1</td>
                <td><b-form-radio v-model="value.LocationOfPart1" :value="1">ÖN</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">1</td>
                <td><b-form-radio v-model="value.LocationOfPart2" :value="1">SOL</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">1</td>
                <td><b-form-radio v-model="value.LocationOfPart3" :value="1">ALT</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">1</td>
                <td><b-form-radio v-model="value.LocationOfPart4" :value="1">KISA</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">1</td>
                <td><b-form-radio v-model="value.LocationOfPart5" :value="1">KÜÇÜK</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">1</td>
                <td><b-form-radio v-model="value.LocationOfPart6" :value="1">YENİ</b-form-radio></td>
            </tr>
            <tr>
                <td class="text-success text-center font-weight-bolder bg-light">2</td>
                <td><b-form-radio v-model="value.LocationOfPart1" :value="2">ARKA</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">2</td>
                <td><b-form-radio v-model="value.LocationOfPart2" :value="2">ORTA</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">2</td>
                <td><b-form-radio v-model="value.LocationOfPart3" :value="2">ÜST</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">2</td>
                <td><b-form-radio v-model="value.LocationOfPart4" :value="2">UZUN</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">2</td>
                <td><b-form-radio v-model="value.LocationOfPart5" :value="2">BÜYÜK</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">2</td>
                <td><b-form-radio v-model="value.LocationOfPart6" :value="2">ESKİ</b-form-radio></td>
            </tr>
            <tr>
                <td class="text-success text-center font-weight-bolder bg-light">3</td>
                <td><b-form-radio v-model="value.LocationOfPart1" :value="3">YAN</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder bg-light">3</td>
                <td><b-form-radio v-model="value.LocationOfPart2" :value="3">SAĞ</b-form-radio></td>
                <td class="text-success text-center font-weight-bolder"></td>
                <td></td>
                <td class="text-success text-center font-weight-bolder"></td>
                <td></td>
                <td class="text-success text-center font-weight-bolder"></td>
                <td></td>
                <td class="text-success text-center font-weight-bolder"></td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import {BFormRadio} from 'bootstrap-vue'
export default {
    components:{
        BFormRadio
    },
    props:{
        value:Object,
        clearable:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        clear(){
            this.value.LocationOfPart1 = null
            this.value.LocationOfPart2 = null
            this.value.LocationOfPart3 = null
            this.value.LocationOfPart4 = null
            this.value.LocationOfPart5 = null
            this.value.LocationOfPart6 = null
        }
    }
}
</script>

<style>

</style>